import React from 'react';
import { defaultTemplate } from 'core/hoc';

const BasicCheckboxTemplate = ({
	field,
	id,
	label,
	checked,
	className = 'input input--check',
	onChangeCallback,
	t,
	disabled,
}) => {
	let props = {};
	if (field) {
		props = { ...field.bind() };
		props.disabled = disabled;
		({ id, label } = field);
		if (onChangeCallback) {
			props.onChange = e => {
				field.onChange(e);
				onChangeCallback(e);
			};
		}
	} else {
		props = { onChange: onChangeCallback, checked, disabled, id };
	}
	return (
		<React.Fragment>
			<input data-cy={`${id}-checkbox`} type="checkbox" className={className} {...props} />
			<label htmlFor={id} data-cy={`${id}-label`}>
				{t(label)}
			</label>
		</React.Fragment>
	);
};

export default defaultTemplate(BasicCheckboxTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/components/forms/BaasicCheckboxTemplate.js